import React, { useState } from "react";
import backimg from "../assets/ContactUs/Backimag-contactus.webp";
import "../pages/Global.css";
import { CheckCircleIcon } from "@heroicons/react/outline";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../pages/Global.css";

const ContactUs = () => {



    const Modal = ({ isOpen, onClose }) => {
        if (!isOpen) return null;
      
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96 text-center">
              <CheckCircleIcon className="w-16 h-16 text-green-500 mx-auto" />
              <h2 className="text-xl font-semibold mt-4">Thank You!</h2>
              <p className="mt-2 text-gray-600">Your enquiry has been submitted. We'll get back to you soon.</p>
              <div className="mt-4">
                <button
                  onClick={onClose}
                  className="px-6 py-1 bg-[#C32A7C] rounded-lg text-white font-semibold hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-lg text-center whitespace-nowrap mt-4"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        );
    };

    const [submitloader, setSubmitloader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        message: "",
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        let newErrors = {};

        if (!formData.first_name.trim()) newErrors.first_name = "First name is required";
        if (!formData.last_name.trim()) newErrors.last_name = "Last name is required";
        
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        
        if (!formData.phone_number.trim()) {
            newErrors.phone_number = "Phone number is required";
        } else if (!/^\d{10}$/.test(formData.phone_number)) {
            newErrors.phone_number = "Phone number must be 10 digits";
        }
        
        if (!formData.message.trim()) newErrors.message = "Message is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [id]: '',
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setSubmitloader(true)
        try {
            const response = await axios.post("https://tekpossible.net/backend/send_email.php", formData);
            if(response && response.data && response.data.success === true){
                setIsOpen(true);
                setFormData({
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone_number: "",
                    message: "",
                });
            }else{
                toast.error(response.data.message);
            }
            setErrors({});
        } catch (error) {
            console.error("Error submitting form:", error.response?.data || error.message);
        }finally{
            setSubmitloader(false);
           
        }
    };

    return (
        <>
            <div
                className="bg-cover bg-center bg-no-repeat min-h-[250px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                style={{ backgroundImage: `url(${backimg})` }}
            >
                <h1 style={{ wordSpacing: "8px" }} data-aos="fade-down" className="text-xl md:text-2xl lg:text-3xl font-semibold text-white max-w-[900px]">
                    We’re just a message away – let’s connect and create something amazing together!
                </h1>
                <p data-aos="fade-down" className="text-white text-sm w-full max-w-[1008px]">
                    We’d love to hear from you! Whether you have a question, need assistance, or want to collaborate, feel free to reach out.
                </p>
            </div>


            <div className="bg-white">
                <div className="text-center mt-10">
                    <h1 className="text-[#1A5298] text-2xl font-bold">Get in Touch</h1>
                    <p className="text-black mt-2">
                        Fill out the form below, and our team will get back to you as soon as possible
                    </p>
                </div>

                <div data-aos="flip-down" className="max-w-3xl mx-auto p-6 md:p-[60px] bg-white shadow-[0_0_16px_rgba(0,0,0,0.2)] rounded-xl mt-10 mb-20">
                    <form onSubmit={handleSubmit}>
                
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
                            <div className="flex-column">
                                <CustomInput id="first_name" label="First Name" value={formData.first_name} onChange={handleChange} />
                                {errors.first_name && <p className="text-red-500 mt-2">{errors.first_name}</p>}
                            </div>

                            <div className="flex-column">
                                <CustomInput id="last_name" label="Last Name" value={formData.last_name} onChange={handleChange} />
                                {errors.last_name && <p className="text-red-500 mt-2">{errors.last_name}</p>}
                            </div>
                        </div>

            
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
                            <div className="flex-column">
                                <CustomInput id="email" label="Email" type="email" value={formData.email} onChange={handleChange} />
                                {errors.email && <p className="text-red-500 mt-2">{errors.email}</p>}
                            </div>
                            <div className="flex-column">
                                <CustomInput id="phone_number" label="Phone Number" type="tel" value={formData.phone_number} onChange={handleChange} />
                                {errors.phone_number && <p className="text-red-500 mt-2">{errors.phone_number}</p>}
                            </div>
                        </div>

                        
                        <div className="mt-10">
                            <textarea
                                className="appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-lg"
                                id="message"
                                placeholder="Your message..."
                                rows="6"
                                value={formData.message}
                                onChange={handleChange}
                            ></textarea>
                            {errors.message && <p className="text-red-500">{errors.message}</p>}
                        </div>

                        <div className="flex items-center justify-start mt-5">
                            <button
                                className="px-6 loader_gif bg-[#C32A7C] rounded-lg text-white font-semibold hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-lg text-center whitespace-nowrap mt-4  border border-[#C32A7C]"
                                type="submit"
                            >
                                {(submitloader === true) ? (
                                    <img src={require('../assets/whiteloader.gif')} alt='' />
                                ) : (
                                    'Send message'
                                )}
                                
                            </button>
                        </div>
                    </form>
                </div>
                <Modal isOpen={isOpen} onClose={() => {setIsOpen(false);navigate("/contact-us")}} />
            </div>
        </>
    );
};


const CustomInput = ({ id, label, type = "text", value, onChange }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div style={{ position: "relative" }}>
            <input
                id={id}
                type={type}
                value={value}
                onChange={onChange}
                autocomplete="new-password"
                data-placeholder={`${label} *`}
                onFocus={() => setIsFocused(true)}
                onBlur={(e) => setIsFocused(e.target.value !== "")}
                className="inputs_focusindex appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-lg"
            />
            {!isFocused || !value ? (
                <span
                    style={{
                        position: "absolute",
                        left: "12px",
                        top: "10px",
                        pointerEvents: "none",
                        color: "#aaa",
                        fontSize: "16px",
                    }}
                >
                    {label} <span style={{ color: "#FF0000" }}>*</span>
                </span>
            ):null}
        </div>
    );
};

export default ContactUs;
